
const RelatedArticleSection = ({ data }) => {
    return (
        <>
            {data?.length > 0
                ? data?.map((article) => (
                    <div style={{ marginBottom: '10px', width: '100%' }}>
                        <a
                            key={article.id}
                            href={`http://candorium.com/news/${article.id}/${article?.title_slug?.toLowerCase()}`}
                            target='_blank'
                            rel='noreferrer'
                            style={{}}>
                            {article.title}
                        </a>
                    </div>
                ))
                : null
            }
        </>
    )
}

export default RelatedArticleSection